import CreatePassword from '../components/Auth/CreatePassword';
import ForgotPassword from '../components/Auth/ForgotPassword';
import Login from '../components/Auth/Login';
import LoginPassword from '../components/Auth/Login/LoginPassword';
import LoginPin from '../components/Auth/Login/LoginPin';
import Logout from '../components/Auth/Logout';
import LoginCallback from '../components/Auth/Okta/LoginCallback';
import OktaLoginWrapper from '../components/Auth/Okta/OktaLoginWrapper';
import BasicInformation from '../components/Auth/Onboarding/BasicInformation';
import { AcceptInvitation } from '../components/Teammates/Invitation/AcceptInvitation';
import { signup } from '../constants/signup.constants';
import { AuthGate } from '../layouts/Auth/AuthGate';

export const accountRoutesConst = {
  Root: '/',
  Login: '/login',
  Logout: '/logout',
  LoginOktaCallback: '/login/callback',
  LoginOktaWrapper: '/login/callback/wrapper',
  LoginPassword: '/login/password',
  LoginPin: '/login/pin',
  Signup: '/signup',
  SignupFlow: '/signup/steps',
  CreatePassword: '/create_password',
  ForgotPassword: '/forgot_password',
  AcceptInvitation: '/accept_invitation',
};

export const firstTimeSetupRoutes: (RoutePropsExtended | RedirectPropsExtended)[] = [
  {
    name: 'signup',
    group: 'first_time_setup',
    path: accountRoutesConst.SignupFlow,
    component: AuthGate,
    exact: true,
  },
  {
    name: 'signup.location',
    group: 'first_time_setup',
    path: signup.paths.location,
    component: AuthGate,
    exact: true,
  },
  {
    name: 'signup.confirm_location',
    group: 'first_time_setup',
    path: signup.paths.locationConfirm,
    component: AuthGate,
    exact: true,
  },
  {
    name: 'signup.survey',
    group: 'first_time_setup',
    path: signup.paths.survey,
    component: AuthGate,
    exact: true,
  },
  {
    name: 'auth.logout',
    group: 'first_time_setup',
    path: accountRoutesConst.Logout,
    component: Logout,
    exact: true,
  },
  {
    name: 'signup.redirect_index',
    group: 'first_time_setup',
    path: '*',
    to: signup.paths.location,
  },
];

export const publicRoutes: (RoutePropsExtended | RedirectPropsExtended)[] = [
  {
    name: 'teammates.accept_invitation',
    group: 'public',
    path: accountRoutesConst.AcceptInvitation,
    component: AcceptInvitation,
    exact: true,
  },
  {
    name: 'auth.login_password',
    group: 'public',
    path: accountRoutesConst.LoginPassword,
    component: LoginPassword,
    exact: true,
  },
  {
    name: 'auth.login_okta_callback',
    group: 'public',
    path: accountRoutesConst.LoginOktaCallback,
    component: LoginCallback,
    exact: true,
  },
  {
    name: 'auth.login_okta_wrapper',
    group: 'public',
    path: accountRoutesConst.LoginOktaWrapper,
    component: OktaLoginWrapper,
    exact: true,
  },
  {
    name: 'auth.login_pin',
    group: 'public',
    path: accountRoutesConst.LoginPin,
    component: LoginPin,
    exact: true,
  },
  {
    name: 'auth.login',
    group: 'public',
    path: accountRoutesConst.Login,
    component: Login,
    exact: true,
  },
  {
    name: 'auth.signup',
    group: 'public',
    path: accountRoutesConst.Signup,
    component: BasicInformation,
    exact: true,
  },
  {
    name: 'auth.create_password',
    group: 'publicAndPrivate',
    path: accountRoutesConst.CreatePassword,
    component: CreatePassword,
    exact: true,
  },
  {
    name: 'auth.forgot_password',
    group: 'public',
    path: accountRoutesConst.ForgotPassword,
    component: ForgotPassword,
    exact: true,
  },
  {
    name: 'auth.redirect_index',
    group: 'public',
    path: '*',
    to: accountRoutesConst.Login,
  },
];
